<script>
import { usePortalStore } from '../../stores/portal'
export default {
  props: {
    to: String,
    disabled: Boolean
  },
  data () {
    return ({
      portalStore: usePortalStore()
    })
  },
  beforeDestroy () {
    this.portalStore.removePortal(this.to, this._uid)
  },
  render () {
    const content = this.$scopedSlots.default({})
    if (this.disabled) return content
    this.portalStore.addPortal(this.to, this._uid, content)
    return null
  }
}
</script>
